import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import CrateUnit from "./CrateUnit";
import UpdateUnit from "./UpdateUnit";
import {
  useGetAllModelQuery,
  useRemoveModelMutation,
} from "../../../features/api/modelApi";
import AddSubCategory from "../SubCategory/AddSubCategory";
import AddProduct from "../Product/AddProduct";

const Unit = () => {
  const { data, isLoading } = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const productModels = data?.data?.filter((d) => d?.subcategory_id !== 10);

  const [removeModel] = useRemoveModelMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const response = await removeModel(id);
        if (!response?.error) {
          toast.success("Delete Success..!!!");
        } else {
          toast.error(response?.error?.data?.error);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = productModels?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="bg-slate-200 h-full">
      <div className="flex justify-between items-center px-2 py-4">
        <h1 className="text-xl font-bold">Product Model</h1>
        <div className="flex items-center gap-4">
          <AddSubCategory />
          <AddProduct />
          <CrateUnit />
        </div>
      </div>
      <input
        type="text"
        placeholder="Search Product"
        className="border ml-2 focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="p-2">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : productModels?.length === 0 ? (
          <p className=" text-xl text-red-500">Product Model not found</p>
        ) : (
          <TableContainer
            component={Paper}
            style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#e6e6e6" }}>
                    Sl No.
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#e6e6e6" }}>
                    Brand
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#e6e6e6" }}>
                    Product / Spare Parts
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#e6e6e6" }}>
                   Machine Model
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#e6e6e6",textAlign:'center' }}>
                    Opening Quantity
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#e6e6e6" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{row?.subCategory}</TableCell>
                      <TableCell>{row?.product}</TableCell>
                      <TableCell>{row?.model_name}</TableCell>
                      <TableCell style={{textAlign:'center'}}>{row?.open_qty}</TableCell>
                      <TableCell className="">
                        <div className="flex items-center gap-x-4">
                          <UpdateUnit productModel={row} />
                          <span onClick={() => handleDelete(row?.model_id)}>
                            <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                          </span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[100, 200, 300]}
              component="div"
              count={productModels?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Unit;
